<template>
    <div>
        <VueDatePicker model-type="HH:mm:ss" :model-value="modelValue" @update:model-value="handleUpdate" time-picker
            :format-locale="th" :time-only="true" auto-apply :placeholder="placeholder" :required="required" :disabled="disabled"/>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { th } from 'date-fns/locale';
import moment from 'moment';
moment.locale('th')

export default defineComponent({
    name: 'TimePicker',
    props: {
        modelValue: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: 'เลือกเวลา'
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        
    },
    data() {
        return {
            th: th
        }
    },
    methods: {
        handleUpdate(value) {
            // Format the time value to HH:mm:ss using Moment.js
            const formattedTime = moment(value, 'HH:mm:ss').format('HH:mm:ss');
            this.$emit('update:model-value', formattedTime); // Emit the formatted time
            this.validate(); // Call the validation method
        },
        validate() {
            if (this.required && !this.modelValue) {
                this.$emit('validation-error', 'Time is required');
            }
        }
    }
});
</script>

<style scoped>
/* Add your styles here */
</style>
